import { render, staticRenderFns } from "./copyrightPage.vue?vue&type=template&id=73e3a37f&"
import script from "./copyrightPage.vue?vue&type=script&lang=js&"
export * from "./copyrightPage.vue?vue&type=script&lang=js&"
import style0 from "./copyrightPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copyrightPage.vue"
export default component.exports